import { ReactNode, useState } from "react";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { AttributeCollection, getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import React from "react";
import GetAttributeDefinition, { AttributeDefinition, AttributeInputType, AttributeTargetType, GetComponentOrStyleValueFromDefinition, GetWBComponentByTypename } from "../Data/WBData";
import { MapInputsFromEditList, UpdateStyleFunction } from "../Stylebuilder";
import { SiteData } from "../Data/SiteData";
import Accordian from "../Accordian";
import SelectDropdown from "../SelectDropdown";
import CreateNodeGlobalStyle, { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";
import { AttributeGroups, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import RenderInputsWithTabs from "../Menus/RenderInputsWithTabs";


export enum ResizeableType {
  All = 0,
  HorizontalOnly = 1,
  VerticalOnly = 2,
  None = 3,
  flexGrow = 4,
}


export class WBComponent {
  typename: string;
  contentEditable: boolean;
  displayName: string;
  description:string;
  displayType:string;
  icon: ReactNode;
  resizeType: ResizeableType;
  resizeVisibilty = [true, true, true];
  dropList: string[];
  editList: string[];
  primaryEditAttributes: string[];
  attributeLabelOverrides: { [key: string]: string };
  isStatic: boolean;
  showTemplateOptions: boolean;
  hideAdvancedSettings:boolean;
  cssDefinitions: NodeCSSClassDefinition[];
  vagaroLink?: string;
  colorFields:string[];
  isSubComponent?: boolean;





  constructor() {

    this.typename = "WBComponent";
    this.contentEditable = false;
    this.icon = <svg xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 448 512"><path d="M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"/></svg>;
    this.displayName = "Unamed Component";
    this.displayType = "flex"
    this.resizeType = ResizeableType.All;
    this.dropList = [];
    this.attributeLabelOverrides = {};
    this.editList = [];
    this.primaryEditAttributes = [];
    this.isStatic = false;
    this.cssDefinitions = [];
    this.showTemplateOptions = false;
    this.hideAdvancedSettings = false;
    this.description = "";

    this.colorFields = [
      attributeTypes.backgroundColor,
      attributeTypes.color,
    ]


  
  }

 GetGlobalFlexStyling(node: LayoutNode,isEditor:boolean = false,isLivePublish= false,targeting="> .flex-wrapper") {


    const realid = (isEditor) ? "#"+node.id : "#v" + node.id;
    let str =  realid +"{gap:0 !important}\n";

    for(let i = 0;i<3;i++){
      const gap =getNodeStyleAttributeValue(node,i,"gap");
      const defaultDir = node.typename === wBComponentTypeNames.column?"column":"row";
      const dir = getNodeStyleAttributeValue(node,i,"flexDirection",defaultDir);
      if(gap!=""){

        
        const halfWidth = parseInt(gap)/2;

        const effect = (dir==="row")?
        `${realid} ${targeting} {margin:0 ${halfWidth}px }
        ${realid} ${targeting}.first {margin:0 ${halfWidth/2}px 0 0}
        ${realid} ${targeting}.last {margin:0 0 0 ${halfWidth/2}px 0}
        `:
        `${realid} ${targeting} {margin: ${halfWidth}px 0 }
        ${realid} ${targeting}.first {margin:0  0 ${halfWidth/2}px 0}
        ${realid} ${targeting}.last {margin: ${halfWidth/2}px 0 0 0}
        `
        if(i==ScreenSize.Desktop){ //desktop size

        str += `${effect} \n`;

        }
        else if(isLivePublish){ //live publish use media queries for tablet and mobile
          if(i==ScreenSize.Tablet){
            str += `@media (max-width: 1200px) { ${effect} \n}`;
          
          }
          else {
            str += `@media (max-width: 767px) { ${effect } \n}`;
          }

        }
        else{ //in editor use tablet and mobile break classes instead so it reflects on canvas
          if(i==ScreenSize.Tablet){
            str += `.tablet-break ${effect} \n`;
          
          }
          else {
            str += `.mobile-break ${effect} \n`;
          }
        }



      }

    }

    return str;
  }

  OnApplyAttribute(component:AttributeCollection, attribute:string, value:string, manager:WebDesigner) {


  }

  RenderLayout({ component, children }: WBRenderProps) : JSX.Element {
    return <div></div>;
  }

  onFirstTimeCreation(
    newParent: LayoutNode,
    thisLayout: LayoutNode,
    manager: WebDesigner
  ) {}

  onPreDeletion(thisLayout: LayoutNode, manager: WebDesigner) {}

  removeIfOneLastSibling(thisLayout: LayoutNode, manager: WebDesigner) {
    if (!thisLayout.parent) return;

    let parent = thisLayout.parent;
    let index = thisLayout.childIndex === 0 ? 1 : 0;
    if (
      parent.children.length === 2 &&
      parent.children[0].typename === thisLayout.typename
    ) {
      let sibling = parent.children[index];
      if (sibling.children.length === 0) manager.deleteObjectById(sibling.id);
    }
  }

  duplicateSelfOnCreation(
    newParent: LayoutNode,
    thisLayout: LayoutNode,
    manager: WebDesigner
  ) {
    if (newParent.children.length === 1) {
      return manager.duplicateOjbectInPlace(thisLayout);
    }
  }

  

  GetComponentGlobalCSS(node: LayoutNode,isEditor:boolean = false,isLivePublish= false) {

    let component = GetWBComponentByTypename(node.typename);

    if(component.cssDefinitions.length<0){
      return "";
    }
    else{
    
      return CreateNodeGlobalStyle(node,isEditor,component.cssDefinitions);
    }

  }

  // Get any nessicarry scritps to run this component
  GetComponentGeneralScripts() {

    return "";
  }


  getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
    return [];
  }

  RenderMenu({
    editList,
    primaryList,
    layoutNode,
    screenSize,
    updateFunc,
    saveFunc,
    showScreenSize = true,
    siteData,

  }: {
    updateFunc:UpdateStyleFunction,
    saveFunc:Function,
    editList: string[];
    primaryList:string[];
    layoutNode: AttributeCollection | null;
    screenSize: ScreenSize;
    showScreenSize?: boolean;
    siteData:SiteData;

  }){

    let filteredList:string[] = [...editList].filter((item) => { 
      
      
      return (!primaryList.includes(item) && item !="width"&& item !="height")
        
    
    
    });

    const comp = (layoutNode)? GetWBComponentByTypename(layoutNode.typename):null;
    const showAdvanced = (!comp||!comp.hideAdvancedSettings)

      return <>
        <MapInputsFromEditList  updateFunc={updateFunc} saveFunc={saveFunc} editList={primaryList} layoutNode={layoutNode} screenSize={screenSize} showScreenSize={showScreenSize} siteData={siteData}/>
        <br></br>

        {showAdvanced && <RenderInputsWithTabs colorList={comp?.colorFields??[]} editList={editList} layoutNode={layoutNode} screenSize={screenSize} updateFunc={updateFunc} saveFunc={saveFunc} siteData={siteData}/>}
  
       {filteredList.length>0&&showAdvanced&&false&& 
      //  <Accordian label={<h2 className="panel-heading">Advanced Settings</h2>} startExpanded={true} wrapperClass="advanced-settings" observerSizeChanges={true}>
      <> <>
      <h2 className="panel-heading" style={{fontSize:"18px",textAlign:"center"}}>Advanced Settings</h2>
         { 
          siteData.editorSettings.advancedMenuIsModular? 
          <RenderModularState key={layoutNode?.id??"modular" + screenSize} updateFunc={updateFunc} saveFunc={saveFunc} editList={filteredList} layoutNode={layoutNode} screenSize={screenSize} siteData={siteData}/>:
          
          
          <>
      
          {
            AttributeGroups.map((group)=>{

              let list = group.attributes.filter((att)=>{return filteredList.includes(att)});

              if(list.length<=0)
                return null;

             return <Accordian key={group.name+"accordian"+layoutNode?.id} observerSizeChanges={true} label={<div className="att-category-label flex-row  align-center">{group.icon}{group.name}</div>}  startExpanded={false} wrapperClass="category-acordian" >
                 <MapInputsFromEditList key={group.name}  updateFunc={updateFunc} saveFunc={saveFunc} editList={list} layoutNode={layoutNode} screenSize={screenSize} showScreenSize={showScreenSize} siteData={siteData} sort={false}/>
              </Accordian>
            })
            }
          </>
         
         }
         </>
          <br></br>
          <br></br>
          </>
        // </Accordian>
  }
      </>
  }


}




function RenderModularState({updateFunc,saveFunc,editList,layoutNode,screenSize,siteData}:{updateFunc:UpdateStyleFunction ,saveFunc: Function,editList:string[],layoutNode:AttributeCollection|null,screenSize:ScreenSize,siteData:SiteData}){

  const [updateState, setUpdateState] = useState(0);


  const onUpdateFunc: UpdateStyleFunction = (att:string, val:string,targetType:AttributeTargetType) => {


    updateFunc(att,val,targetType);
  }

  const onAnyChange = () => {

    setUpdateState(updateState + 1);
  }

  return <RenderModularMenu key = {updateState+"mod-menu"} onChange = {onAnyChange} updateFunc={onUpdateFunc} saveFunc={saveFunc} editList={editList} layoutNode={layoutNode} screenSize={screenSize} siteData={siteData}/>
}

function RenderModularMenu({updateFunc,saveFunc,editList,layoutNode,screenSize,siteData,onChange}:{onChange:Function,updateFunc:UpdateStyleFunction ,saveFunc: Function,editList:string[],layoutNode:AttributeCollection|null,screenSize:ScreenSize,siteData:SiteData}){



  const availableOptions: { label: ReactNode; value: string; }[] = [];

  const filteredList:string[] = [...editList].filter((item) => { 
      
      
   

    let definition = GetAttributeDefinition(item);

    if(!definition||!layoutNode)
      return false;

 
     

      let val = GetComponentOrStyleValueFromDefinition(definition,layoutNode,screenSize,"",false);

    
      
      if(val===""){
        if(definition.inputType!= AttributeInputType.Ignore)
        availableOptions.push({label:definition.label,value:definition.attKey});
        return false;

      }
    return true;
  
  
  });

  availableOptions.sort((a,b)=>{
    return (a.label as string).localeCompare(b.label as string);
  }
  );
  availableOptions.splice(0,0,{label:"Add New Styling",value:"+"});




  return (
    <>

      <MapInputsFromEditList
        key = {layoutNode?.id??"modular" + screenSize}
        modular={true}
        sort={true}
        onDeleteModular={onChange}
        updateFunc={updateFunc}
        saveFunc={ ()=>{}}
        editList={filteredList}
        layoutNode={layoutNode}
        screenSize={screenSize}
        showScreenSize={true}
        siteData={siteData}
      />
            <div className="flex-row justify-center add-styling-button" >
        <div className = "flex-row justify-center" 
        style={{ width: "100%",border:"1px solid #c9c9c9", background:"#white",borderRadius:"4px"}}>
          <SelectDropdown
            options={availableOptions}
            hideSelectedInMenu = {true}
            additionalStyle={{ width: "100%",display:"flex",justifyContent:"center",alignItems:"center"}}
            defaultValue="+"
            onChange={(val: string) => {
              if (val != "+" && !filteredList.includes(val)) {

                let def = GetAttributeDefinition(val);
                if(def){

                  let defVal = " ";
                  if(def.options.length>0){
                    for(let i = 0;i<def.options.length;i++){
                      if(def.options[i].value!=""){
                        defVal = def.options[i].value;
                        break;
                      }
                    }
                  }


                updateFunc(val,defVal, def.targetType);
              }
                onChange();
              
              }
            }}
          />
        </div>
      </div>
    </>
  );


}